import {MonitorReducer, ReducerFromState} from "../../../@types/reducers";

export const getTemplates = (state: ReducerFromState<MonitorReducer>): string[] => state.monitor.templates;